// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { PromiseDelegate } from '@lumino/coreutils';
import { Widget } from '@lumino/widgets';
/**
 * The MIME type for IFrame.
 */
const MIME_TYPE = 'text/html-sandboxed';
/**
 * A class for rendering an IFrame document.
 */
export class RenderedIFrame extends Widget {
    constructor() {
        super();
        this.addClass('jp-IFrameContainer');
        this._iframe = document.createElement('iframe');
        this.node.appendChild(this._iframe);
    }
    /**
     * Render the IFrame into this widget's node.
     */
    async renderModel(model) {
        var _a, _b;
        if (this._iframe.parentNode) {
            this._iframe.parentNode.removeChild(this._iframe);
        }
        const ready = new PromiseDelegate();
        this._iframe = document.createElement('iframe');
        this._iframe.onload = () => {
            ready.resolve(void 0);
        };
        this.node.appendChild(this._iframe);
        await ready.promise;
        const data = model.data[MIME_TYPE];
        if (!data || !this._iframe.contentWindow) {
            return;
        }
        const metadata = model.metadata[MIME_TYPE];
        this._iframe.width = (_a = metadata === null || metadata === void 0 ? void 0 : metadata.width) !== null && _a !== void 0 ? _a : '100%';
        this._iframe.height = (_b = metadata === null || metadata === void 0 ? void 0 : metadata.height) !== null && _b !== void 0 ? _b : '400px';
        this._iframe.contentWindow.document.write(data);
    }
    /**
     * Dispose of the resources held by the iframe widget.
     */
    dispose() {
        this._iframe.remove();
        super.dispose();
    }
}
/**
 * A mime renderer factory for IFrame data.
 */
export const rendererFactory = {
    safe: false,
    mimeTypes: [MIME_TYPE],
    defaultRank: 100,
    createRenderer: (options) => new RenderedIFrame(),
};
const extensions = [
    {
        id: '@jupyterlite/iframe-extension:factory',
        rendererFactory,
        dataType: 'string',
        documentWidgetFactoryOptions: {
            name: 'IFrame',
            primaryFileType: 'IFrame',
            fileTypes: ['IFrame'],
            defaultFor: ['IFrame'],
        },
    },
];
export default extensions;
